import { Outlet, createFileRoute, notFound } from "@tanstack/react-router";

import { eventsApiClient } from "@/shared/libs/api";

export const Route = createFileRoute("/_auth/org/$orgId/event/$eventId")({
  component: EventLayout,
  beforeLoad: async ({ params }) => {
    const event = await eventsApiClient.getOne(params.eventId);
    if (!event) {
      throw notFound();
    }
    return { event };
  },
  notFoundComponent: () => {
    return <div className="w-screen h-screen flex items-center justify-center">Event does not exist</div>;
  },
  pendingComponent: () => {
    return <div className="w-screen h-screen flex items-center justify-center">Loading Event Info...</div>;
  }
});

function EventLayout() {
  return <Outlet />;
}
